(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('LoyaltyController', LoyaltyController);

  /** @ngInject */
  function LoyaltyController(
    $scope,
    $q,
    $state,
    dialogsService,
    campaignActions,
    userGroupActions,
    CampaignsViewModel,
    $mdDialog
  ) {
    var vm = this;
    vm.campaigns = new CampaignsViewModel();

    vm.createCampaign = function () {
      $state.go('app.loyalty.newCampaign');
    };

    vm.updateCampaign = function (campaign) {
      $state.go('app.loyalty.editCampaign', {
        id: campaign.id,
        facilityType: campaign.facilityType
      });
    };

    vm.deleteCampaign = function () {
      dialogsService
        .showConfirmDialog('CONFIRM_DELETE_CAMPAIGN', 'CONFIRM_DELETE_CAMPAIGN_TEXT', 'DELETE')
        .then(function () {
          campaignActions.deleteCampaign(vm.campaigns.selected[0].id).then(
            function () {
              init();
            },
            function () {
              vm.campaigns.hasErrorMessage = true;
            }
          );
        });
    };

    vm.onCampaignSelected = function () {
      if (vm.campaigns.selected.length >= 2) {
        vm.campaigns.selected.shift();
      }
      /* eslint-disable */
      if (this.model.tresholdEnabled) {
        vm.campaigns.from = new Date(this.model.from);
        vm.campaigns.to = new Date(this.model.to);
        vm.campaigns.onPeriodFromChanged();
        vm.campaigns.onPeriodToChanged();

        vm.campaigns.tresholdTypes = [];
        if (this.model.hasAmountOfMoneyRule) {
          vm.campaigns.tresholdTypes.push({
            id: 'MONEY',
            name: 'TOTAL_MONEY_SPENT'
          });
        }
        if (this.model.hasNumberOfVisitsRule) {
          vm.campaigns.tresholdTypes.push({
            id: 'VISITS',
            name: 'NUMBER_OF_VISITS'
          });
        }
        vm.campaigns.selectedTresholdType = vm.campaigns.tresholdTypes[0].id;
        // vm.campaigns.getTresholds();
      }
    };

    vm.showLoyaltyPreview = function (ev, data) {
      $mdDialog.show({
        controller: loyaltyPreviewController,
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'app/loyalty/loyaltyPreview.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { data: data }
      });
    };

    // to-do implement this in a separate file (dialog to be separate component)
    function loyaltyPreviewController($mdDialog, data) {
      var that = this;
      // close add new dialog
      that.closeDialog = function () {
        $mdDialog.hide();
      };
      that.previewCampaign = function (campaign) {
        $mdDialog.hide();
        $state.go('app.loyalty.editCampaign', {
          id: campaign.id,
          facilityType: campaign.facilityType
        });
      };
    }
    /* eslint-enable */

    init();

    function init() {
      $q.all([
        campaignActions.getCampaigns(),
        userGroupActions.getUserGroups()
      ]).then(function (jsonResponses) {
        vm.campaigns.refresh(jsonResponses[0], jsonResponses[1]);
      });

      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      vm.campaigns.destroy();
    }
  }
})();
